// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".typeDiv[data-v-3172bb9d] {\n  display: flex;\n  margin-bottom: 0.1rem;\n}\n.typeDiv > div[data-v-3172bb9d] {\n    width: 0.5rem;\n    height: 0.3rem;\n    border: 1px solid #606266;\n    line-height: 0.3rem;\n    text-align: center;\n}\n.typeDiv > div[data-v-3172bb9d]:last-child {\n    border-left: none;\n}\n.checkType[data-v-3172bb9d] {\n  background-color: #DB4E1A;\n  color: white;\n  border: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
